module.exports = __webpack_public_path__ + "static/media/599.705493(9).dc3889b0.pdf";